import React, { useCallback, useEffect, useRef } from 'react';

const ChatList = ({ 
  chats, 
  currentChatId, 
  onSelectChat, 
  loading, 
  loadingMore, 
  hasNext, 
  onLoadMore,
  pagination 
}) => {
  const listRef = useRef(null);
  const loadingRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (!hasNext || loadingMore || loading) return;

    const list = listRef.current;
    const loadingElement = loadingRef.current;
    
    if (!list || !loadingElement) return;

    const listRect = list.getBoundingClientRect();
    const loadingRect = loadingElement.getBoundingClientRect();
    
    // Проверяем, виден ли элемент загрузки
    if (loadingRect.top <= listRect.bottom) {
      onLoadMore();
    }
  }, [hasNext, loadingMore, loading, onLoadMore]);

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;

    list.addEventListener('scroll', handleScroll);
    return () => list.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <div className="chat-list" ref={listRef}>
      <h3>Chats</h3>
      {pagination && pagination.total > 0 && (
        <div className="pagination-info">
          {chats.length >= pagination.total 
            ? `All ${pagination.total} chats loaded`
            : `Showing ${chats.length} of ${pagination.total} chats`
          }
        </div>
      )}
      {loading ? (
        <div className="loading">Loading chats...</div>
      ) : chats.length === 0 ? (
        <div className="no-chats">No chats yet. Create one to get started!</div>
      ) : (
        <>
          <ul className="chat-items">
            {chats.map(chat => (
              <li 
                key={chat.id}
                className={`chat-item ${currentChatId === chat.id ? 'active' : ''}`}
                onClick={() => onSelectChat(chat.id)}
              >
                <div className="chat-name" title={chat.name}>{chat.name}</div>
                <div className="chat-date">
                  {new Date(chat.created_at).toLocaleDateString()}
                </div>
              </li>
            ))}
          </ul>
          
          {hasNext && chats.length < pagination.total && (
            <div ref={loadingRef} className="load-more-container">
              {loadingMore ? (
                <div className="loading-more">Loading more chats...</div>
              ) : (
                <button 
                  className="load-more-btn"
                  onClick={onLoadMore}
                  disabled={loadingMore}
                >
                  Load More
                </button>
              )}
            </div>
          )}
          
          {(!hasNext || chats.length >= pagination.total) && chats.length > 0 && (
            <div className="no-more-chats">
              Все чаты загружены
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ChatList;
